import Analytics from '@/utils/analytics';
import React from 'react';
import { FONTS, ThemedSVGProps, TYPOGRAPHY } from '@/styles';
import { StyleSheet, Text, TouchableOpacity } from 'react-native';
import { SvgProps } from 'react-native-svg';
import { TrackingData } from '@/utils/analytics/base-reporter';

interface Props {
  backgroundColor: string;
  Icon: React.FC<SvgProps>;
  iconProps: ThemedSVGProps;
  onPress: () => void;
  text: string;
  textColor?: string;
  trackingData: TrackingData | null;
}

export const OrderGuideRightAction: React.FC<Props> = ({
  backgroundColor,
  Icon,
  iconProps,
  onPress,
  text,
  trackingData,
  textColor,
}) => {
  return (
    <TouchableOpacity
      onPress={() => {
        if (trackingData) {
          Analytics.track(trackingData.name, trackingData.properties);
        }
        onPress();
      }}
      style={[styles.base, { backgroundColor }]}
    >
      <Icon height={21} width={21} {...iconProps} />
      <Text style={[TYPOGRAPHY.xsmall, { color: textColor }, styles.text]}>
        {text}
      </Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  base: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },
  text: {
    ...FONTS.primarySemiBold,
    flexShrink: 0,
    lineHeight: 14,
    marginHorizontal: 0,
    marginTop: 4,
    textAlign: 'center',
  },
});
